module.exports = __webpack_public_path__ + "img/hyperledger.a9f6db2c.png";